import React from 'react';
import Text from 'components/Text';
import { DateOutputStr } from 'utils/DateOutput';

const AutoCompleteLotModel: React.FC = (props: any) => {
  const { item } = props;
  return (
    <>
      <Text className="text-left color-blue-gray pt-1" size={13}>
        {item.identifier}
      </Text>
      <Text className="text-left pb-1" size={10}>
        {`${DateOutputStr(item.manufacturingDate, 'dd/MM/yyyy')} - 
        ${DateOutputStr(item.expirationDate, 'dd/MM/yyyy')}`}
      </Text>
    </>
  );
};

export default AutoCompleteLotModel;
